import type { CatServiceAPIProductOption } from 'src/services/cat-service-api/types/CatServiceAPIProductOption';
import type { CatServiceAPIResponseBody } from 'src/services/cat-service-api/types/CatServiceAPIResponseBody';
import type { ProductState } from '../types';

const partnerLocationIsValid = (location: string) => {
  return location.length > 1 && !/please/i.test(location);
};

/** Normalise option payload from cat-service (camelCase + snake_case min/max images). */
export const normalizeProductOption = (
  raw: CatServiceAPIProductOption & Record<string, unknown>,
): CatServiceAPIProductOption => {
  const minImages =
    raw.minImages ?? (typeof raw.min_images === 'number' ? raw.min_images : null) ?? null;
  const maxImages =
    raw.maxImages ?? (typeof raw.max_images === 'number' ? raw.max_images : null) ?? null;

  return {
    ...raw,
    minImages,
    maxImages,
  };
};

// This should not adapt the whole product slice of the store, only the parts coming from cat-service-api
export const adaptCatServiceAPIResponseForStore = (
  catServiceAPIResponseBody: CatServiceAPIResponseBody,
): Omit<ProductState, 'attributes' | 'publicAttributes'> => {
  const { metaDescription, metaRobotsIndexable, navigation, product } = catServiceAPIResponseBody;
  const { partner } = product;
  const { deliveryOptions, options, returnsInformation, ...restOfProduct } = product;

  return {
    error: null,
    ...{
      ...restOfProduct,
      options: options.map((o) =>
        normalizeProductOption(o as CatServiceAPIProductOption & Record<string, unknown>),
      ),
      partner: {
        ...product.partner,
        location: partnerLocationIsValid(partner.location) ? partner.location : '',
      },
    },
    navigation,
    metaDescription,
    metaRobotsIndexable,
  };
};
